import { fg } from '@atlassian/jira-feature-gating';

const getContentPanelNode = () => `
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;

const getContentPanelsConnectionQuery = () => `
    contentPanels {
        edges {
            node {
                ${getContentPanelNode()}
            }
        }
    }
`;

const getLegacyContentPanelsConnectionQuery = () => `
    legacyContentPanels {
        edges {
            node {
                ${getContentPanelNode()}
            }
        }
    }
`;

export const getContentPanelsQuery = () => `
    ${!fg('nike-dfo-consolidate-viewissue-contentpanels-all') ? getContentPanelsConnectionQuery() : ''}
    ${!fg('nike-dfo-consolidate-viewissue-contentpanels-all') ? getLegacyContentPanelsConnectionQuery() : ''}
    hasCustomisedContentPanels
`;
